import definition from './users.service';

/**
 * UsersApi settings
 * @type {{name: string, definition: UsersApi}}
 */
export default {
    name: 'UsersApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/users/index.js